import { render, staticRenderFns } from "./QuestFrame.vue?vue&type=template&id=74a5af79&scoped=true"
import script from "./QuestFrame.vue?vue&type=script&lang=js"
export * from "./QuestFrame.vue?vue&type=script&lang=js"
import style0 from "./QuestFrame.vue?vue&type=style&index=0&id=74a5af79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5af79",
  null
  
)

export default component.exports